import { Link } from "react-router-dom";
import { Fingerprint, IdCard, Share2, Sparkles, ScrollText, Users } from "lucide-react";
import HubPage from "@/components/shell/HubPage";
import ExplorerCards from "@/components/home/ExplorerCards";
import FavouriteCareers from "@/components/home/FavouriteCareers";
import UnconventionalRoles from "@/components/home/UnconventionalRoles";
import { Button } from "@/components/ui/button";
import { useCareerDna } from "@/hooks/useCareerDna";
import { useAssessmentEntry } from "@/hooks/useAssessmentEntry";

export default function DnaHub() {
  const { data: dna } = useCareerDna();
  const entry = useAssessmentEntry();
  const sealed = Boolean(dna?.archetypePrimary) && !dna?.isLocalPreview && !dna?.isPreview;
  const reportTo = sealed ? "/report" : entry.to;

  return (
    <HubPage
      title="Career DNA™"
      intro="Who you are today, what you're good at, and how to share it."
      path="/hub/dna"
      groups={[
        {
          title: "Your results",
          links: [
            { to: reportTo, label: "Your report", hint: sealed ? "Your full Career DNA™ story" : entry.helper, icon: Fingerprint },
            { to: "/skills", label: "Skills", hint: "What carries you forward, and what to build", icon: Sparkles },
            { to: "/portfolio", label: "My Portfolio", hint: "Human Potential Transcript", icon: ScrollText },
          ],
        },
        {
          title: "Share",
          links: [
            { to: "/card", label: "Career Identity Card", hint: "Your card, ready to save", icon: IdCard },
            { to: "/clarity-card", label: "Clarity Card", hint: "Share with family on WhatsApp or PDF", icon: Share2 },
            { to: "/second-opinion", label: "Second opinion", hint: "Ask someone who knows you", icon: Users },
          ],
        },
      ]}
    >
      <ExplorerCards />
      <FavouriteCareers />
      <UnconventionalRoles />
      <Button asChild size="lg" className="h-12 w-full rounded-2xl text-base">
        <Link to="/careers">Explore all careers</Link>
      </Button>
    </HubPage>
  );
}
